/** Dropdown options shared by card freeze / unfreeze request forms (CMS API reason enum). */
export const CARD_REQUEST_REASON_OPTIONS = [
    'CUSTOMER_REQUEST',
    'SUSPECTED_FRAUD',
    'LOST',
    'STOLEN',
    'SECURITY_REVIEW',
    'COMPLIANCE_HOLD',
    'DUPLICATE_TRANSACTION',
    'SUSPICIOUS_ACTIVITY',
].map(v => ({ name: v, value: v }));
export const CARD_REQUEST_SOURCE_OPTIONS = ['BRANCH', 'MOBILE_APP', 'CALL_CENTER', 'BACK_OFFICE', 'ONLINE'].map(v => ({
    name: v,
    value: v,
}));
/** Card freeze request edit — same reason enum as create. */
export const CARD_FREEZE_EDIT_REASON_OPTIONS = CARD_REQUEST_REASON_OPTIONS;
/** Freeze request edit dialog — status dropdown. */
export const CARD_FREEZE_STATUS_OPTIONS = [
    'PENDING_APPROVAL',
    'SUBMITTED',
    'ACTIVE',
    'REJECTED',
    'CANCELLED',
    'CLOSED',
].map(v => ({ name: v, value: v }));
